import React from 'react';
import PropTypes from 'prop-types';
import { Calendar } from '@vds/calendars';
// import './button.css';

class CalenderVds extends React.PureComponent {
  render() {
    // const { children } = this.props;
    return (
      <Calendar
        minDate={this.props.minDate}
        inactiveDates={this.props.inactiveDates}
        maxDate={this.props.maxDate}
        onChange={this.props.onChange}
        width={this.props.width}
        selectedDate={this.props.selectedDate}
        // activeStartDate={this.props.activeStartDate}
      />
    );
  }
}


CalenderVds.propTypes = {
  minDate: PropTypes.object,
  inactiveDates: PropTypes.array,
  maxDate: PropTypes.object,
  onChange: PropTypes.func,
  width: PropTypes.string,
  selectedDate: PropTypes.object,
  // activeStartDate: PropTypes.object,
};
export default CalenderVds;
